import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import { Button } from '@components/Button';
import Restriction from '@components/Restriction';

import { useCustomContext } from '../context';

import style from './Incomplete.scss';

const cn = bemCssModules(style, 'Incomplete');
const ti = getTestId('Incomplete');

export const Incomplete: CustomFC = ({ className }) => {
  const { t, onBack, startKYC } = useCustomContext();

  return (
    <Restriction
      className={cn(null, [className])}
      title={t('public.verification_incomplete')}
      subtitle={t('public.verification_incomplete_description')}
      images={['/img/verification_incomplete.png']}
      button={
        <Button onClick={startKYC} testId={ti('button')}>
          {t('public.verification_incomplete_continue')}
        </Button>
      }
      backButton={onBack}
      testId={ti()}
    />
  );
};

export default Incomplete;
